import React, { useContext, useState, useRef, useEffect } from 'react';
import { Row, Col, Stack } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import MuiBreadcrumbs from 'components/common/MuiBreadcrumbs';
import { providerAdminSpecialists } from 'routes/AppUrls';
import LabelWithInput from 'components/common/Input/LabelWithInput';
import SelectInput from 'components/common/Input/SelectInput';
import PhoneNumberInput from 'components/common/Input/PhoneNumberInput';
import ProfileIcon from 'assets/images/navbar/profileIcon.png';
import AddBlackColor from 'assets/images/Dashboard/addBlackColor.png';
import crossIcon from 'assets/images/provider/crossIcon.png';
import ReusableButton from 'components/common/Button';
import { getUserRole } from 'utils/general';
import { countryCityDropdownCallAPI } from 'store/CountryCityList/action';
import { useDispatch, useSelector } from 'react-redux';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { imageUploadCallAPI } from 'store/ImageUpload/action';
import ToastNotification from 'components/common/Toast';
import CheckValidation from 'utils/Validation';
import { createSpecialistProviderCallAPI } from 'store/ProviderAdmin/createSpecialistProvider/action';
import { getCompanyBranchProviderCallAPI } from 'store/ProviderAdmin/getCompanyBranchProvider/action';
import CircularProgress from '@mui/material/CircularProgress';
import MultiSelectChip from 'components/common/Input/MultiSelectChip';
import { getServiceOfferedCallAPI } from 'store/ProviderAdmin/serviceOffered/action';
import { getAllProviderListDetailsCallAPI } from 'store/SuperAdmin/getAllProviderListDetails/action';
import { updateSpecialistCallAPI } from 'store/ProviderAdmin/updateSpecialist/action';

const AddSpecialist = () => {
  const navigate = useNavigate();
  const userRole = getUserRole();
  const dispatch = useDispatch();
  const [conf, setConf] = ToastNotification();
  const intl = useIntl();
  const { locale } = useContext(LocaleContext);
  const [latLng, setLatLng] = useState({ lat: 28.525377, lng: 77.280106 });

  const brandImageFileInputRef = useRef();
  const specialistImageRef = useRef();
  const [brandImageFile, setBrandImageFile] = useState(null);
  const [specialistImages, setSpecialistImages] = useState([]);
  const [serviceOfferedList, setServiceOfferedList] = useState([]);
  const [selectedOfferedService, setSelectedOfferedService] = useState([]);

  const [isError, setIsError] = useState(null);
  const phoneNumberInputRef = useRef(null);
  const alternatePhoneNumberInputRef = useRef(null);

  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);
  const [isAlternatePhoneNumberValid, setIsAlternatePhoneNumberValid] =
    useState(true);

  const countryCityData = useSelector(
    (state) => state?.countryCityDropdownReducer?.data?.data
  );
  const getBranchListData = useSelector(
    (state) => state?.getCompanyBranchProviderReducer?.data?.data
  );
  const addSpecialistLoader = useSelector(
    (state) => state?.createSpecialistProviderReducer?.loading
  );
  const profileData = useSelector((state) => state?.userMeReducer?.data?.data);
  const getSpecialistId = useSelector(
    (state) => state?.basicDetailsReducer?.specialistId
  );
  const updateSpecialistLoader = useSelector(
    (state) => state?.updateSpecialistReducer?.loading
  );

  const [formValue, setFormValue] = useState({
    specialistName: '',
    addressArea: '',
    country: '',
    city: '',
    branch: '',
    phoneNumber: '',
    countryCode: '+974',
    alternatePhoneNumber: '',
    countryCodeAlternateNumber: '+974',
    email: '',
    alternateEmail: '',
    about: '',
    brandImage: '',
    bussinessImages: [],
  });

  const [formId, setFormId] = useState({
    country: '',
    city: '',
    branch: '',
  });

  useEffect(() => {
    getCountryCityList();
    getServiceOfferedDropDownData();
    {
      userRole === 'company-admin' && getBranchList();
    }
    getEditDetails();
  }, []);

  const getEditDetails = () => {
    if (getSpecialistId) {
      let data = {
        id: getSpecialistId,
      };

      dispatch(
        getAllProviderListDetailsCallAPI(
          { data },
          {
            run: true,
            handleFunction: (res) => handleProviderListData(res),
            navigate: navigate,
          }
        )
      );
    }
  };

  const handleProviderListData = (res) => {
    setFormValue({
      specialistName:
        locale === 'en'
          ? res?.data?.data?.name?.name_en
          : res?.data?.data?.name?.name_ar,
      addressArea: res?.data?.data?.address,
      country: res?.data?.data?.country?.name,
      city: res?.data?.data?.city?.name,
      branch: '',
      phoneNumber: res?.data?.data?.contact_number,
      countryCode: res?.data?.data?.country_code,
      alternatePhoneNumber: res?.data?.data?.alternate_contact_number,
      countryCodeAlternateNumber: res?.data?.data?.alternate_country_code,
      email: res?.data?.data?.email,
      alternateEmail: res?.data?.data?.alternate_email,
      about:
        locale === 'en'
          ? res?.data?.data?.about_information_en
          : res?.data?.data?.about_information_ar,
      brandImage: res?.data?.data?.profile_photo?.id,
      bussinessImages: res?.data?.data?.bussiness_images?.map((k) => k?.id),
    });

    setFormId({
      country: res?.data?.data?.country?.id,
      city: res?.data?.data?.city?.id,
      branch: '',
    });

    setSelectedOfferedService(res?.data?.data?.specialist_services_details);
    setBrandImageFile(res?.data?.data?.profile_photo?.file_url);
    setSpecialistImages(
      res?.data?.data?.bussiness_images?.map((k) => k?.image)
    );
  };

  const getBranchList = () => {
    dispatch(
      getCompanyBranchProviderCallAPI(
        {},
        {
          navigate: navigate,
        }
      )
    );
  };

  const getCountryCityList = () => {
    dispatch(countryCityDropdownCallAPI({}, { naviagte: navigate }));
  };

  const getServiceOfferedDropDownData = () => {
    dispatch(
      getServiceOfferedCallAPI(
        {},
        {
          run: true,
          handleFunction: (res) => handleServiceOfferedSuccess(res),
          navigate: navigate,
        }
      )
    );
  };

  const handleServiceOfferedSuccess = (res) => {
    setServiceOfferedList(res?.data?.data);
  };

  const handleServiceOfferedSelect = (data) => {
    setSelectedOfferedService(data);
  };

  const [breadcrumbsList, setBreadcrumbsList] = useState([
    {
      title: <FormattedMessage id="Specialists" />,
      Link: providerAdminSpecialists(locale),
      isDisable: false,
    },
    {
      title: <FormattedMessage id="Specialist’s Details" />,
      Link: '',
      isDisable: true,
    },
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValue({
      ...formValue,
      [name]: value?.name || value?.searched_business_name_en,
    });
    setFormId({ ...formId, [name]: value?.id });
    if (name === 'city') {
      setLatLng({ lat: value?.latitude, lng: value?.longitude });
    }
  };

  const handleBrandImageFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      let formData = new FormData();
      formData.append('filePath', file);
      formData.append('fileType', 'I');
      dispatch(
        imageUploadCallAPI(formData, {
          navigate: navigate,
          run: true,
          handleFunction: (res) => handleSuccess(res),
        })
      );
      setBrandImageFile(URL.createObjectURL(file));
    }
  };

  const handleSuccess = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    setFormValue({ ...formValue, ['brandImage']: res?.data?.data?.[0]?.id });
  };

  const handleSpecialistImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      let formData = new FormData();
      formData.append('filePath', file);
      formData.append('fileType', 'I');
      dispatch(
        imageUploadCallAPI(formData, {
          navigate: navigate,
          run: true,
          handleFunction: (res) => handleSpecialistImagesSuccess(res),
        })
      );
      setSpecialistImages([...specialistImages, URL.createObjectURL(file)]);
    }
  };

  const handleSpecialistImagesSuccess = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    setFormValue({
      ...formValue,
      ['bussinessImages']: [
        ...formValue?.bussinessImages,
        res?.data?.data?.[0]?.id,
      ],
    });
  };

  const handleBrandImageUpload = () => {
    brandImageFileInputRef.current.click();
  };

  const handleSpecialistImageUpload = () => {
    specialistImageRef.current.click();
  };

  const handleDeleteSpecialistImage = (data, index) => {
    const filterImages = specialistImages?.filter((value) => value !== data);
    setSpecialistImages(filterImages);
  };

  const handleCountryCodeChange = (value, name) => {
    if (name === 'alternatePhoneNumber') {
      setFormValue({ ...formValue, countryCodeAlternateNumber: value });
    } else if (name === 'phoneNumber') {
      setFormValue({ ...formValue, countryCode: value });
    }
  };

  const handlePhoneNumberChange = (e) => {
    const phoneNumberValue = e.target.value.replace(/\D/g, '');
    setFormValue((prev) => ({
      ...prev,
      [e.target.name]: phoneNumberValue,
    }));

    if (e.target.name === 'phoneNumber') {
      const fullPhoneNumber = `+${formValue?.countryCode}${phoneNumberValue}`;
      const parsedPhoneNumber = parsePhoneNumberFromString(fullPhoneNumber);
      if (parsedPhoneNumber) {
        setIsPhoneNumberValid(parsedPhoneNumber.isValid());
      } else {
        setIsPhoneNumberValid(false);
      }
    } else if (e.target.name === 'alternatePhoneNumber') {
      const fullPhoneNumber = `+${formValue?.countryCodeAlternateNumber}${phoneNumberValue}`;
      const parsedPhoneNumber = parsePhoneNumberFromString(fullPhoneNumber);
      if (parsedPhoneNumber) {
        setIsAlternatePhoneNumberValid(parsedPhoneNumber.isValid());
      } else {
        setIsAlternatePhoneNumberValid(false);
      }
    }
  };

  const handleSubmit = () => {
    const { specialistName, country, city, phoneNumber, email, branch } =
      formValue;
    const error = CheckValidation({
      specialistName,
      country,
      city,
      phoneNumber,
      email,
      ...(userRole === 'company-admin' && { branch }),
    });
    setIsError(error);
    if (error.submit) {
      if (!formValue?.brandImage) {
        return setConf({
          msg: 'Brand image is required. Please upload a brand image.',
          variant: 'error',
        });
      }

      let body = {
        master_provider_id:
          userRole === 'company-admin'
            ? formId?.branch
            : profileData?.provider_details?.id,
        [getSpecialistId ? 'name_en' : 'specialist_name_en']:
          formValue?.specialistName,
        [getSpecialistId ? 'name_ar' : 'specialist_name_ar']:
          formValue?.specialistName,
        address: formValue?.addressArea,
        country: formId?.country,
        city: formId?.city,
        contact_number: formValue?.phoneNumber,
        is_contact_verified: false,
        alternate_contact_number: formValue?.alternatePhoneNumber,
        is_alternate_contact_verified: false,
        email: formValue?.email?.toLowerCase(),
        is_email_verified: false,
        alternate_email: formValue?.alternateEmail?.toLowerCase(),
        is_alternate_email_verified: false,
        about_information_en: formValue?.about,
        about_information_ar: formValue?.about,
        profile_photo: formValue?.brandImage,
        branch_images: formValue?.bussinessImages,
        service_specialist_ids:
          (selectedOfferedService?.length > 0 &&
            selectedOfferedService.map((k) => k?.id)) ||
          [],
      };
      if (getSpecialistId) {
        const data = {
          id: getSpecialistId,
          body,
        };
        dispatch(
          updateSpecialistCallAPI(data, {
            run: true,
            latlng: latLng,
            handleFunction: (res) => handleRedirect(res),
            navigate: navigate,
            toast: true,
            handleToastError: (res) => handleRedirectError(res),
          })
        );
      } else {
        dispatch(
          createSpecialistProviderCallAPI(body, {
            run: true,
            latlng: latLng,
            handleFunction: (res) => handleRedirect(res),
            navigate: navigate,
            toast: true,
            handleToastError: (res) => handleRedirectError(res),
          })
        );
      }
    }
  };

  const handleRedirect = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    navigate(providerAdminSpecialists(locale));
  };

  const handleRedirectError = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'error',
    });
  };

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        <MuiBreadcrumbs size="14" list={breadcrumbsList} />
        <Row className="bc-FFFFFF m-0 p-16 mt-3">
          <h2 className="fc-292D32 fs-32 fw-400 ff-Akkurat_Bold m-0">
            <FormattedMessage
              id={
                getSpecialistId
                  ? 'Edit Specialist Details'
                  : 'Add New Specialist'
              }
            />
          </h2>

          <Row className="m-0 p-0">
            <input
              ref={brandImageFileInputRef}
              type="file"
              accept=".png, .jpg, .jpeg"
              disabled={false}
              style={{ display: 'none' }}
              onChange={handleBrandImageFileChange}
            />

            <div className="mt-4">
              <p className="p-0 m-0 fs-18 fc-292D32 fw-400 ff-Akkurat_Bold">
                <FormattedMessage id="Photos" />{' '}
                <span
                  style={{
                    color: 'red',
                    fontSize: '14px',
                  }}
                >
                  *
                </span>
              </p>
              <Stack
                direction="horizontal"
                gap={4}
                className="items-center mt-4"
              >
                <div className="AvtarImageIcon">
                  {brandImageFile && (
                    <img
                      src={brandImageFile}
                      alt={'icon'}
                      style={{
                        height: '88px',
                        width: '88px',
                        borderRadius: '50%',
                      }}
                    />
                  )}
                  <img
                    src={ProfileIcon}
                    alt="icon"
                    style={{ height: '32px', width: '32px' }}
                    className="profileIcon"
                    onClick={handleBrandImageUpload}
                  />
                </div>
                <div>
                  <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                    <FormattedMessage id="Upload Brand Image" />
                  </p>
                  <p className="p-0 m-0 fs-14 fc-9A9A9A fw-400 ff-Akkurat">
                    <FormattedMessage id="A picture will help people recognize you" />
                  </p>
                </div>
              </Stack>
            </div>

            <Col xs={12} md={12} className="mt-3">
              <div className="flex justify-between items-center">
                <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                  <FormattedMessage id="Images" />
                </p>
                {specialistImages?.length > 0 && (
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#292D32"
                    fontSize="16px"
                    fontWeight="400"
                    padding="12px 25px"
                    height="44px"
                    bgColor="transparent"
                    fontFamily="Akkurat"
                    onClick={handleSpecialistImageUpload}
                  >
                    <img
                      src={AddBlackColor}
                      alt="icon"
                      style={{ height: '24px', width: '24px' }}
                      className="me-2"
                    />
                    <FormattedMessage id="Add Images" />
                  </ReusableButton>
                )}
              </div>

              <input
                ref={specialistImageRef}
                type="file"
                accept=".png, .jpg, .jpeg"
                disabled={false}
                style={{ display: 'none' }}
                onChange={handleSpecialistImageChange}
              />

              {specialistImages?.length <= 0 ? (
                <div className="mt-2 bussinessImages flex justify-center align-center">
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center cursor-pointer"
                    onClick={handleSpecialistImageUpload}
                  >
                    <img
                      src={AddBlackColor}
                      alt="icon"
                      style={{ height: '24px', width: '24px' }}
                    />
                    <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                      <FormattedMessage id="AddImageEn" />
                    </p>
                  </Stack>
                </div>
              ) : (
                <div className="flex flex-wrap gap-2 mt-3">
                  {specialistImages.map((key, index) => (
                    <div className="relative">
                      <img
                        src={key}
                        alt="image"
                        style={{ height: '122px', width: '246px' }}
                      />
                      <img
                        src={crossIcon}
                        alt="icon"
                        style={{ height: '24px', width: '24px' }}
                        className="absolute top-2 right-2 cursor-pointer"
                        onClick={() => handleDeleteSpecialistImage(key, index)}
                      />
                    </div>
                  ))}
                </div>
              )}
            </Col>

            <Col xs={12} md={6} className="mt-3">
              <LabelWithInput
                label={<FormattedMessage id="Specialist’s Name" />}
                required={true}
                placeholder={intl.formatMessage({
                  id: 'Specialist’s Name',
                })}
                name="specialistName"
                type="text"
                value={formValue?.specialistName}
                onChange={handleChange}
                errorText={
                  isError &&
                  isError.specialistName.error &&
                  isError.specialistName.errorMessage
                }
              />
            </Col>

            <Col xs={12} md={6} className="mt-3">
              {userRole === 'company-admin' && (
                <SelectInput
                  label={
                    <FormattedMessage id="Select a branch to add the Specialist to" />
                  }
                  required={true}
                  placeholder={intl.formatMessage({
                    id: 'Select a branch to add the Specialist to',
                  })}
                  name={'branch'}
                  value={formValue?.branch}
                  data={getBranchListData ?? []}
                  onChange={(e) => handleInputChange(e)}
                  errorText={
                    isError &&
                    isError?.branch?.error &&
                    isError?.branch?.errorMessage
                  }
                />
              )}

              {userRole === 'salon-admin' && (
                <>
                  <p className="p-0 m-0 mt-3 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                    <FormattedMessage id="Services Offered" />{' '}
                    <span
                      style={{
                        color: 'red',
                        fontSize: '14px',
                      }}
                    >
                      *
                    </span>
                  </p>
                  <div className="mt-2">
                    <MultiSelectChip
                      options={serviceOfferedList}
                      onSelect={(selected) =>
                        handleServiceOfferedSelect(selected)
                      }
                      onRemove={(removed) =>
                        handleServiceOfferedSelect(removed)
                      }
                      onSearch={(searchTerm) => console.log(searchTerm)}
                      height="50px"
                      dropdownBg="#fff7ed"
                      chipBg="#22c55e" // Tailwind green-500
                      value={selectedOfferedService}
                    />
                  </div>
                </>
              )}
            </Col>

            <Col xs={12} md={6} className="mt-3">
              <LabelWithInput
                label={<FormattedMessage id="Address of the serving area" />}
                placeholder={intl.formatMessage({
                  id: 'Address of the serving area',
                })}
                name="addressArea"
                type="text"
                value={formValue?.addressArea}
                onChange={handleChange}
              />
            </Col>

            <Col xs={12} md={3} className="mt-3">
              <SelectInput
                label={<FormattedMessage id="Country" />}
                required={true}
                placeholder={intl.formatMessage({ id: 'Country' })}
                name={'country'}
                value={formValue?.country}
                data={countryCityData}
                onChange={(e) => handleInputChange(e)}
                errorText={
                  isError &&
                  isError.country.error &&
                  isError.country.errorMessage
                }
              />
            </Col>

            <Col xs={12} md={3} className="mt-3">
              <SelectInput
                label={<FormattedMessage id="City" />}
                required={true}
                placeholder={intl.formatMessage({ id: 'City' })}
                name={'city'}
                value={formValue?.city}
                data={
                  countryCityData?.find(
                    (value) => value?.name === formValue?.country
                  )?.city || []
                }
                onChange={(e) => handleInputChange(e)}
                errorText={
                  isError && isError.city.error && isError.city.errorMessage
                }
              />
            </Col>

            <Col xs={12} md={6} className="mt-3">
              <PhoneNumberInput
                label={<FormattedMessage id="Contact Number" />}
                required={true}
                country={'qa'}
                value={formValue?.countryCode}
                name={'phoneNumber'}
                onCountryCodeChange={(e) =>
                  handleCountryCodeChange(e, 'phoneNumber')
                }
                onPhoneNumberChange={handlePhoneNumberChange}
                phoneNumber={formValue.phoneNumber}
                phoneNumberRef={phoneNumberInputRef}
                isPhoneNumberValid={isPhoneNumberValid}
                isError={
                  isError &&
                  isError?.phoneNumber?.error &&
                  isError?.phoneNumber?.errorMessage
                }
                errorMessage="Invalid phone number for selected country code"
              />
            </Col>

            <Col xs={12} md={6} className="mt-3">
              <PhoneNumberInput
                label={<FormattedMessage id="Alternate Contact Number" />}
                country={'qa'}
                value={formValue?.countryCodeAlternateNumber}
                name={'alternatePhoneNumber'}
                onCountryCodeChange={(e) =>
                  handleCountryCodeChange(e, 'alternatePhoneNumber')
                }
                onPhoneNumberChange={handlePhoneNumberChange}
                phoneNumber={formValue.alternatePhoneNumber}
                phoneNumberRef={alternatePhoneNumberInputRef}
                isPhoneNumberValid={isAlternatePhoneNumberValid}
                errorMessage="Invalid phone number for selected country code"
              />
            </Col>

            <Col xs={12} md={6} className="mt-3">
              <LabelWithInput
                label={<FormattedMessage id="Email Address" />}
                required={true}
                placeholder={intl.formatMessage({ id: 'Email Address' })}
                name="email"
                type="text"
                value={formValue?.email}
                onChange={handleChange}
                errorText={
                  isError && isError.email.error && isError.email.errorMessage
                }
              />
            </Col>

            <Col xs={12} md={6} className="mt-3">
              <LabelWithInput
                label={<FormattedMessage id="Alternate Email Address" />}
                placeholder={intl.formatMessage({
                  id: 'Alternate Email Address',
                })}
                name="alternateEmail"
                type="text"
                value={formValue?.alternateEmail}
                onChange={handleChange}
              />
            </Col>

            <Col xs={12} md={12} className="mt-3">
              <LabelWithInput
                label={<FormattedMessage id="About/Information" />}
                placeholder={intl.formatMessage({
                  id: 'About/Information',
                })}
                height="100"
                multiline
                name="about"
                value={formValue?.about}
                onChange={(e) => handleChange(e)}
              />
            </Col>
          </Row>

          <Row className="mt-4 items-end m-0 p-0">
            <div className="flex justify-end">
              <Stack direction="horizontal" gap={3} className="items-center">
                <ReusableButton
                  fullWidth={false}
                  variant="outlined"
                  color="#292D32"
                  fontSize="16px"
                  fontWeight="400"
                  padding="12px 25px"
                  height="44px"
                  bgColor="transparent"
                  fontFamily="Akkurat"
                  onClick={() => navigate(-1)}
                >
                  <FormattedMessage id="Cancel" />
                </ReusableButton>

                <ReusableButton
                  fullWidth={false}
                  variant="contained"
                  color="#F5F5F5"
                  fontSize="16px"
                  fontWeight="400"
                  padding="12px 25px"
                  height="44px"
                  bgColor="#292D32"
                  fontFamily="Akkurat"
                  endIcon={
                    (addSpecialistLoader || updateSpecialistLoader) && (
                      <CircularProgress
                        style={{
                          color: 'white',
                          width: '20px',
                          height: '20px',
                        }}
                      />
                    )
                  }
                  onClick={() => handleSubmit()}
                >
                  <FormattedMessage id="Send Invitation" />
                </ReusableButton>
              </Stack>
            </div>
          </Row>
        </Row>
      </Col>
    </Row>
  );
};

export default AddSpecialist;
